module.exports = __webpack_public_path__ + "img/Menu-10.61e92a12.png";